import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-card-hover-effect',
    templateUrl: './card-hover-effect.component.html',
    styleUrls: ['./card-hover-effect.component.scss'],
    standalone: false
})
export class CardHoverEffectComponent implements OnInit {
  @Input() cardImage: string;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() subTitle2: string;

  @Input() field1: string;
  @Input() fieldContent1: string;
  @Input() field2: string;
  @Input() fieldContent2: string;

  @Input() field3: string;
  @Input() fieldContent3: string;
  @Input() field4: string;
  @Input() fieldContent4: string;

  @Input() field5: string;
  @Input() fieldContent5: string;
  @Input() field6: string;
  @Input() fieldContent6: string;

  @Input() field7: string;
  @Input() fieldContent7: string;
  @Input() field8: string;
  @Input() fieldContent8: string;

  @Input() field9: string;
  @Input() fieldContent9: string;
  @Input() field10: string;
  @Input() fieldContent10: string;


  @Input() eventName: string;
  @Input() eventDate: string;


  constructor() { }

  ngOnInit() {
  }

}
